<script>
import Loader from './Loader.vue';
/**
 * Report Deal Modal.
 * Made using https://vuejs.org/v2/examples/modal.html
 */
export default {
    components: { Loader },
    props: { deal: Object },

    data() {
        return {
            isLoading: false,
            reasons: [],
            selectedReason: 1,
            comment: '',
        };
    },

    async mounted() {
        this.reasons = await this.getReasons();
    },

    methods: {
        async getReasons() {
            const response = await window.axios.get('/api/user/reasons');
            return response.data;
        },

        async submitReport() {
            this.isLoading = true;

            try {
                await window.axios.post(
                    '/api/user/report', 
                    { 
                        deal_id: this.deal.id, 
                        reason_id: this.selectedReason, 
                        comment: this.comment,
                    },
                );
            } catch (error) {
                this.isLoading = false;
                // Close the popup modal
                this.$emit('close');
                return;
            } finally {
                this.isLoading = false;
                // Close the popup modal
                this.$emit('close');
            }

            


            Vue.toasted.show(
                'Report received. Thank you!', 
                { duration: 6000, icon: 'check' },
            );
        },
    },
};
</script>

<template lang='pug' src='./template/ReportModal.pug'></template>
<style lang='stylus' src='./styles/ReportModal.styl' scoped></style>
